<!-- NAVBAR-->
<nav class="navbar navbar-expand-lg py-3 fixed-top affix" [ngClass]="{'affix-scroll': pageYoffset > 50}">
    <div class="container-fluid">
        <a [href]="user ? '#' : '#/login'" class="navbar-brand">
            <!-- Logo Image -->
            <img src="assets/images/logo.png" class="align-middle">
        </a>

        <!-- Nav Items -->
        <div class="mr-auto">
            <app-categories-menu></app-categories-menu>
        </div>

        <!-- Right Corner -->
        <div class="float-right">
            <!-- Search Input -->
            <app-search-input *ngIf="user"></app-search-input>

            <!-- Settings -->
            <a class="d-inline-block px-4 cursor-po-c" [href]="'#/settings'">
                <i class="fa fa-cog"></i>
            </a>

            <!-- Login for guest -->
            <a class="d-inline-block px-4 cursor-po-c" [href]="'#/login'" *ngIf="user && user?.isGuest">
                <i class="fa fa-user mr-3"></i> {{'gen_login' | translate}}
            </a>

            <!-- User Profile -->
            <div class="d-inline-block pl-3" *ngIf="user && !user.isGuest">
                <button mat-button [matMenuTriggerFor]="userMenu">
                    <img class="user-avatar" [src]="'assets/images/avatars/avatar' + user.avatar + '.png'" />
                    {{user.displayName}}
                </button>
                <mat-menu #userMenu="matMenu">
                    <a mat-menu-item href="#/account">
                        <i class="fas fa-house-user mr-2"></i> {{'gen_my_account' | translate}}
                    </a>
                    <a mat-menu-item (click)="switchProfile()" *ngIf="features.hasProfiles">
                        <i class="fas fa-users mr-2"></i> {{'gen_switch_profile' | translate}}
                    </a>

                    <!-- Lists Items -->
                    <a mat-menu-item [matMenuTriggerFor]="lists">
                        <i class="fas fa-th-list mr-2"></i> {{'gen_my_lists' | translate}}
                    </a>
                    <mat-menu #lists="matMenu">
                        <a mat-menu-item [href]="'#/lists/bookmarks'">
                            <i class="fas fa-bookmark mr-2"></i>{{'gen_bookmarks' | translate }}
                        </a>
                        <a mat-menu-item [href]="'#/lists/myList'">
                            <i class="fas fa-list-ul mr-2"></i>{{'gen_my_list' | translate }}
                        </a>
                        <a mat-menu-item [href]="'#/lists/viewingHistory'">
                            <i class="fas fa-history mr-2"></i>{{'gen_viewing_history' | translate }}
                        </a>
                        <a mat-menu-item [href]="'#/lists/rates'">
                            <i class="fas fa-star mr-2"></i>{{'gen_rates_list' | translate }}
                        </a>
                        <a mat-menu-item [href]="'#/lists/rentalsHistory'">
                            <i class="fas fa-shopping-cart mr-2"></i>{{'gen_rentals_history' | translate }}
                        </a>
                    </mat-menu>
                    <a mat-menu-item href="#/tvlogin" *ngIf="features.hasTVLogin">
                        <i class="fas fa-sign-in-alt mr-2"></i> {{'gen_tv_login' | translate}}
                    </a>
                    <a mat-menu-item (click)="logOut()">
                        <i class="fas fa-sign-out-alt mr-2"></i> {{'gen_log_out' | translate}}
                    </a>
                </mat-menu>
            </div>
        </div>
    </div>
</nav>